import React, { useState, useEffect } from "react";
import Popup from "reactjs-popup";

const ATLTinkerpreneurPopUp = ({ year }) => {
  const [isOpen, setOpen] = useState(true);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("body-no-scroll");
    } else {
      document.body.classList.remove("body-no-scroll");
    }

    return () => {
      document.body.classList.remove("body-no-scroll");
    };
  }, [isOpen]);

  return (
    isOpen && (
      <Popup
        trigger={<button style={{ display: "none" }}></button>}
        position="top center"
        open={isOpen}
        closeOnDocumentClick={false}
        overlayStyle={{
          backgroundColor: "rgba(0, 0, 0, 0.80)",
          overflow: "hidden",
        }}
      >
        <div
          className="d-flex flex-column align-items-center p-4 rounded-3 shadow-lg"
          style={{ backgroundColor: "white" }}
        >
          <h2 className="mt-3">India AI Tinkerpreneur {year}</h2>
          <p className="text-center mb-4">
            <strong>Hurry up! Registration closes soon.</strong>
            <br />
            Don’t miss India’s biggest AI innovation and entrepreneurship
            session for students and Mentor of change/Teacher!
          </p>

          <div className="w-100 mb-3">
            <h5 className="txt txt-primary text-center">
              <strong>Register As</strong>
            </h5>
          </div>

          <div className="d-flex flex-wrap justify-content-center w-100 gap-3 mt-3">
            <button
              onClick={() => {
                setOpen(false);
                localStorage.setItem("showTinkerpreneurPopUp", true);
              }}
              className="btn btn-primary rounded-3 mx-2 my-1 px-4 text-white"
              style={{ minWidth: "120px" }}
            >
              Student
            </button>
            <button
              onClick={() => {
                window.location.href = `https://aifacilitator.community/ai-tinkerpreneur-${year}`;
                localStorage.setItem("showTinkerpreneurPopUp", true);
              }}
              className="btn btn-danger rounded-3 mx-2 my-1 px-4 text-white"
              style={{ minWidth: "120px" }}
            >
              Mentor of change/Teacher
            </button>
          </div>
        </div>
      </Popup>
    )
  );
};

export default ATLTinkerpreneurPopUp;
